import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const polarisProductGlobalViewsSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-polaris-settings-global-views", jiraSpaEntry: "async-polaris-ideas" */ './src/PolarisGlobalViewsSettingsPage'
			),
	),
	getPreloadProps: () => ({}),
});
